// extracted by mini-css-extract-plugin
export var apiError = "api-error-message-module--api-error--suJI9";
export var warningIcon = "api-error-message-module--warning-icon--p4APC";